const toDisplayPercent = (fraction: number): number => Math.round(fraction * 10000) / 100 || 0;

export const fractionToEditablePercent = (fraction: number): number => Math.round(fraction * 1e8) / 1e6;

export const formatInterestRate = (fraction: number, language: string | undefined): string => {
  const percent = toDisplayPercent(fraction);
  const fractionDigits = Number.isInteger(percent) ? 0 : 2;
  const locale = language?.toLowerCase().startsWith("no") ? "nb-NO" : "en-GB";
  const number = new Intl.NumberFormat(locale, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(percent);
  return `${number} %`;
};
